import styled from "styled-components";

export const MainContainerLotacao = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 10px;
  gap: 16px;
  width: 90vw;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
`;

export const ContainerLotacao = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 16px 0px;
  gap: 16px;
  width: 90vw;
`;

export const SmallText = styled.span`
  font-size: 14px;
  color: #666;
  margin-top: 4px;
`;

